<template>
    <div class="giftcards-section">
        <div class="giftcards-content">
            <h2 class="giftcards-title fuente-posm">
                Gift cards digitales
            </h2>
            <p class="giftcards-text fuente-nova">
                Vende tarjetas de regalo digitales bajo tu marca, listas para usarse desde cualquier dispositivo. Tus clientes pueden comprarlas, enviarlas o guardarlas en su celular, y usarlas directamente en tu punto de venta o en línea.
                <br><br>
                Tú decides el valor, el diseño y las reglas. Nosotros nos encargamos de que todo funcione fácil y seguro.
            </p>
        </div>
        <div class="giftcards-image">
            <img :src="a68" alt="Gift Cards Digitales">
        </div>
    </div>
</template>

<script>
export default {
    name: 'GiftCardsDigitalesNew',
    data() {
        return {
            a68: require('@/assets/images/a68.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.giftcards-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.giftcards-content {
    flex: 1;
    max-width: 600px;
    order: 1;
}

.giftcards-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.giftcards-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

.giftcards-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.giftcards-image img {
    width: 75%;
    max-width: 400px;
    height: auto;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .giftcards-title {
        font-size: 60px;
    }

    .giftcards-text {
        font-size: 27px;
    }

    .giftcards-image img {
        max-width: 320px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .giftcards-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .giftcards-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .giftcards-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .giftcards-image img {
        width: 70%;
        max-width: 250px;
    }

    .giftcards-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .giftcards-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
